import React from 'react'

export default function SucessfullyLoggedOut() {
  return (
    <div style={{paddingTop: 100, marginLeft: '20%', marginRight: '20%', textAlign: 'center'}}>
      <h1>Success Logging Out. Click The Home Page on the Top Left to Return.</h1>
      </div>
  )
}
